(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-notification"] && !Shopify.designMode) return;
  try {
    (() => {
    const mutationEvent = 'md:cozy-cart-mutated';
    const giftMarker = '_cozy_sunday_gift';
    const giftMarkerValue = '2026-09-13';

    if (!document.querySelector('cozy-sunday-gift')) return;

    if (!window.__mdCozySundayFetchWrapped) {
      const originalFetch = window.fetch;

      window.fetch = function (...args) {
        return originalFetch.apply(this, args).then((response) => {
          try {
            const input = args[0];
            const options = args[1] || {};
            const rawUrl = typeof input === 'string' ? input : input.url;
            const inputMethod = typeof input === 'string' ? '' : input.method;
            const method = String(options.method || inputMethod || 'GET').toUpperCase();
            const path = new URL(rawUrl, window.location.origin).pathname;

            if (
              method !== 'GET' &&
              /\/cart\/(add|change|update|clear)(\.js)?$/.test(path)
            ) {
              window.setTimeout(() => window.dispatchEvent(new CustomEvent(mutationEvent)), 0);
            }
          } catch (error) {
            return response;
          }

          return response;
        });
      };

      window.__mdCozySundayFetchWrapped = true;
    }

    class CozySundayGift extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        const drawer = document.querySelector('cart-notification');
        const scrollArea = drawer && drawer.querySelector('.md-cart-scroll');
        const regularProgress = scrollArea && scrollArea.querySelector('.md-cart-progress');
        const template = this.querySelector('[data-md-cozy-template]');

        if (!drawer || !scrollArea || !regularProgress || !template) return;

        const fragment = template.content.cloneNode(true);
        this.panel = fragment.querySelector('[data-md-cozy-panel]');
        regularProgress.before(fragment);

        this.initialized = true;
        this.drawer = drawer;
        this.itemsContainer = drawer.querySelector('[data-md-cart-items]');
        this.thresholdCents = Number(this.dataset.thresholdCents || 4900);
        this.giftProductId = String(this.dataset.giftProductId || '');
        this.giftVariantId = Number(this.dataset.giftVariantId || 0);
        this.giftPriceCents = Number(this.dataset.giftPriceCents || 0);
        this.giftAvailable = this.dataset.giftAvailable === 'true';
        this.startsAt = Date.parse(this.dataset.startsAt || '');
        this.endsAt = Date.parse(this.dataset.endsAt || '');
        this.discountTitle = String(this.dataset.discountTitle || '');
        this.qualifyingProductIds = new Set(
          String(this.dataset.qualifyingProductIds || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean)
        );
        this.locked = false;
        this.rerun = false;
        this.pending = false;
        this.failed = false;
        this.soldOut = false;
        this.boundSchedule = () => this.schedule(130);
        this.boundSubmit = (event) => {
          if (!this.pending && !this.locked) return;
          event.preventDefault();
          this.schedule(0);
        };

        window.addEventListener(mutationEvent, this.boundSchedule);
        window.addEventListener('pageshow', this.boundSchedule);
        this.drawer.addEventListener('submit', this.boundSubmit, true);

        if (this.itemsContainer) {
          this.observer = new MutationObserver(this.boundSchedule);
          this.observer.observe(this.itemsContainer, { childList: true });
        }

        if (Number.isFinite(this.endsAt)) {
          const expiryDelay = this.endsAt - Date.now() + 1000;
          if (expiryDelay > 0) {
            this.expiryTimer = window.setTimeout(
              () => this.schedule(0),
              Math.min(expiryDelay, 2147483647)
            );
          }
        }

        this.schedule(0);
      }

      disconnectedCallback() {
        if (!this.initialized) return;
        window.removeEventListener(mutationEvent, this.boundSchedule);
        window.removeEventListener('pageshow', this.boundSchedule);
        this.drawer.removeEventListener('submit', this.boundSubmit, true);
        if (this.observer) this.observer.disconnect();
        window.clearTimeout(this.scheduleTimer);
        window.clearTimeout(this.expiryTimer);
        window.clearTimeout(this.noticeTimer);
      }

      schedule(delay = 130) {
        this.pending = true;
        this.setCheckoutPending(true);
        window.clearTimeout(this.scheduleTimer);
        this.scheduleTimer = window.setTimeout(() => this.reconcile(), delay);
      }

      async reconcile() {
        if (!this.panel) return;

        if (this.locked) {
          this.rerun = true;
          return;
        }

        this.locked = true;
        this.pending = false;
        this.rerun = false;

        try {
          let cart = await this.getCart();
          const now = Date.now();
          const activeTime =
            Number.isFinite(this.startsAt) &&
            Number.isFinite(this.endsAt) &&
            now >= this.startsAt &&
            now <= this.endsAt;
          const isEur = String(cart.currency || '').toUpperCase() === 'EUR';

          if (!activeTime || !isEur) {
            if (this.markedGiftLines(cart).length > 0) {
              cart = await this.removeMarkedGiftLines(cart);
              this.syncDrawer(cart);
            }
            document.documentElement.classList.remove('md-cozy-active');
            this.panel.hidden = true;
            return;
          }

          this.panel.hidden = false;

          if (!this.giftAvailable || this.soldOut) {
            if (this.markedGiftLines(cart).length > 0) {
              cart = await this.removeMarkedGiftLines(cart);
              this.syncDrawer(cart);
            }
            document.documentElement.classList.remove('md-cozy-active');
            this.showState('unavailable', cart, 0);
            return;
          }

          document.documentElement.classList.add('md-cozy-active');
          const eligibleCents = this.eligibleSubtotal(cart);
          let markedLines = this.markedGiftLines(cart);

          if (eligibleCents < this.thresholdCents) {
            this.failed = false;
            const hadGift = markedLines.length > 0;
            if (hadGift) {
              cart = await this.removeMarkedGiftLines(cart);
              this.syncDrawer(cart);
            }
            this.showState('progress', cart, eligibleCents);
            if (hadGift) this.showRemovalNotice();
            return;
          }

          if (markedLines.length > 0) {
            const markedQuantity = markedLines.reduce(
              (total, item) => total + Number(item.quantity || 0),
              0
            );
            const needsNormalization = markedLines.length > 1 || markedQuantity !== 1;

            if (needsNormalization) {
              cart = await this.normalizeMarkedGift(cart);
              markedLines = this.markedGiftLines(cart);
              this.syncDrawer(cart);
            }

            if (await this.waitForCozyDiscount(cart)) {
              cart = await this.getCart();
              this.showState('added', cart, eligibleCents);
              this.decorateGiftLine(cart);
              return;
            }

            cart = await this.removeMarkedGiftLines(await this.getCart());
            this.syncDrawer(cart);
            this.failed = true;
            this.showState('error', cart, eligibleCents);
            return;
          }

          if (this.failed) {
            this.showState('error', cart, eligibleCents);
            return;
          }

          this.showState('adding', cart, eligibleCents);

          try {
            await this.postJson(this.dataset.cartAddUrl, {
              items: [
                {
                  id: this.giftVariantId,
                  quantity: 1,
                  properties: {
                    [giftMarker]: giftMarkerValue
                  }
                }
              ]
            });
          } catch (error) {
            if (error.status === 422) this.soldOut = true;
            else this.failed = true;
            this.showState(error.status === 422 ? 'unavailable' : 'error', cart, eligibleCents);
            return;
          }

          cart = await this.getCart();

          if (!(await this.waitForCozyDiscount(cart))) {
            cart = await this.removeMarkedGiftLines(await this.getCart());
            this.syncDrawer(cart);
            this.failed = true;
            this.showState('error', cart, eligibleCents);
            return;
          }

          cart = await this.normalizeMarkedGift(await this.getCart());
          this.syncDrawer(cart);
          this.showState('added', cart, eligibleCents);
          this.decorateGiftLine(cart);
        } catch (error) {
          this.failed = true;
          this.showState('error', null, 0);
        } finally {
          this.locked = false;
          if (this.rerun) this.schedule(140);
          else this.setCheckoutPending(false);
        }
      }

      async getCart() {
        const response = await fetch(this.dataset.cartJsonUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) {
          const error = new Error('Cart could not be loaded');
          error.status = response.status;
          throw error;
        }

        return response.json();
      }

      async postJson(url, body) {
        const response = await fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(body)
        });

        if (!response.ok) {
          const error = new Error('Cart could not be updated');
          error.status = response.status;
          throw error;
        }

        return response.json();
      }

      markedGiftLines(cart) {
        return (cart.items || []).filter((item) => {
          return (
            String(item.product_id) === this.giftProductId &&
            item.properties &&
            item.properties[giftMarker] === giftMarkerValue
          );
        });
      }

      eligibleSubtotal(cart) {
        return (cart.items || []).reduce((total, item) => {
          if (!this.qualifyingProductIds.has(String(item.product_id))) return total;
          if (item.properties && item.properties[giftMarker] === giftMarkerValue) return total;
          return total + Number(item.final_line_price || 0);
        }, 0);
      }

      cozyDiscountAmount(cart) {
        return (cart.items || [])
          .filter((item) => String(item.product_id) === this.giftProductId)
          .reduce((total, item) => {
            const allocations = item.line_level_discount_allocations || [];
            return total + allocations.reduce((sum, allocation) => {
              const application = allocation.discount_application || {};
              if (String(application.title || '') !== this.discountTitle) return sum;
              return sum + Number(allocation.amount || 0);
            }, 0);
          }, 0);
      }

      requiredGiftDiscount(cart) {
        return (cart.items || [])
          .filter((item) => String(item.product_id) === this.giftProductId)
          .reduce((lowest, item) => {
            const unitPrice = Number(item.original_price || item.price || 0);
            if (unitPrice <= 0) return lowest;
            return lowest === 0 ? unitPrice : Math.min(lowest, unitPrice);
          }, 0) || this.giftPriceCents;
      }

      hasCozyDiscount(cart) {
        const required = this.requiredGiftDiscount(cart);
        return required > 0 && this.cozyDiscountAmount(cart) >= required;
      }

      async waitForCozyDiscount(initialCart) {
        let cart = initialCart;
        if (this.hasCozyDiscount(cart)) return true;

        for (let attempt = 0; attempt < 3; attempt += 1) {
          await this.wait(180 + attempt * 100);
          cart = await this.getCart();
          if (this.hasCozyDiscount(cart)) return true;
        }

        return false;
      }

      async removeMarkedGiftLines(cart) {
        let currentCart = cart;

        for (let index = 0; index < 10; index += 1) {
          const line = this.markedGiftLines(currentCart)[0];
          if (!line) break;
          currentCart = await this.postJson(this.dataset.cartChangeUrl, {
            id: line.key,
            quantity: 0
          });
        }

        return currentCart;
      }

      async normalizeMarkedGift(cart) {
        let currentCart = cart;
        let lines = this.markedGiftLines(currentCart);

        if (lines.length > 0 && Number(lines[0].quantity || 0) !== 1) {
          currentCart = await this.postJson(this.dataset.cartChangeUrl, {
            id: lines[0].key,
            quantity: 1
          });
        }

        for (let index = 0; index < 9; index += 1) {
          lines = this.markedGiftLines(currentCart);
          if (lines.length <= 1) break;
          currentCart = await this.postJson(this.dataset.cartChangeUrl, {
            id: lines[1].key,
            quantity: 0
          });
        }

        return currentCart;
      }

      syncDrawer(cart) {
        if (this.drawer && typeof this.drawer.renderCart === 'function') {
          this.drawer.renderCart(cart);
        }
        this.decorateGiftLine(cart);
      }

      setCheckoutPending(pending) {
        const button = this.drawer && this.drawer.querySelector('button[name="checkout"]');
        if (!button) return;
        button.disabled = Boolean(pending);
        button.setAttribute('aria-busy', pending ? 'true' : 'false');
      }

      showState(state, cart, eligibleCents) {
        if (!this.panel) return;

        const safeEligible = Math.max(0, Number(eligibleCents || 0));
        const progress = Math.min(100, (safeEligible / this.thresholdCents) * 100);
        const remaining = Math.max(0, this.thresholdCents - safeEligible);
        const currency = cart && cart.currency ? cart.currency : 'EUR';

        this.panel.hidden = false;
        this.panel.dataset.state = state;
        this.panel.querySelectorAll('[data-md-cozy-state]').forEach((node) => {
          node.hidden = node.dataset.mdCozyState !== state;
        });

        const remainingNode = this.panel.querySelector('[data-md-cozy-remaining]');
        if (remainingNode) remainingNode.textContent = this.formatMoney(remaining, currency);

        const progressNode = this.panel.querySelector('[data-md-cozy-progress]');
        const fillNode = this.panel.querySelector('[data-md-cozy-progress-fill]');

        if (progressNode) {
          progressNode.setAttribute(
            'aria-valuenow',
            String(Math.min(this.thresholdCents, safeEligible) / 100)
          );
          progressNode.setAttribute(
            'aria-valuetext',
            this.formatMoney(safeEligible, currency) +
              ' ' +
              this.dataset.copyOf +
              ' ' +
              this.formatMoney(this.thresholdCents, currency)
          );
        }

        if (fillNode) fillNode.style.width = progress + '%';
      }

      showRemovalNotice() {
        const notice = this.panel && this.panel.querySelector('[data-md-cozy-notice]');
        if (!notice) return;
        notice.hidden = false;
        window.clearTimeout(this.noticeTimer);
        this.noticeTimer = window.setTimeout(() => {
          notice.hidden = true;
        }, 4500);
      }

      decorateGiftLine(cart) {
        if (!this.itemsContainer || !cart) return;

        const marked = this.markedGiftLines(cart)[0];
        if (!marked) return;

        const index = (cart.items || []).findIndex((item) => item.key === marked.key);
        const articles = this.itemsContainer.querySelectorAll('.md-cart-item');
        const article = index >= 0 ? articles[index] : null;
        if (!article) return;

        article.classList.add('md-cart-item--cozy');

        const content = article.querySelector('.md-cart-item__content');
        const title = article.querySelector('.md-cart-item__title');

        if (content && title && !content.querySelector('.md-cozy-line-badge')) {
          const badge = document.createElement('span');
          badge.className = 'md-cozy-line-badge';
          badge.textContent = this.dataset.copyGiftBadge;
          content.insertBefore(badge, title);
        }

        const price = article.querySelector('.md-cart-item__price');
        if (price && this.hasCozyDiscount(cart)) {
          price.textContent = this.dataset.copyFree;
        }
      }

      formatMoney(cents, currency) {
        if (this.drawer && typeof this.drawer.formatMoney === 'function') {
          return this.drawer.formatMoney(cents, currency);
        }

        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
            style: 'currency',
            currency: currency || 'EUR'
          }).format((Number(cents) || 0) / 100);
        } catch (error) {
          return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' €';
        }
      }

      wait(milliseconds) {
        return new Promise((resolve) => window.setTimeout(resolve, milliseconds));
      }
    }

    if (!customElements.get('cozy-sunday-gift')) {
      customElements.define('cozy-sunday-gift', CozySundayGift);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["melt-it-forward"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('melt-forward-gift')) return;
    const rawFetch = window.fetch.bind(window);
    const mutationEvent = 'md:forward-cart-mutated';
    let mutations = 0;

    window.fetch = function (...args) {
      let changesCart = false;
      try {
        const input = args[0];
        const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.origin);
        const method = String(args[1]?.method || input?.method || 'GET').toUpperCase();
        changesCart = url.origin === location.origin && method !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
      } catch (error) {}
      if (changesCart) {
        mutations += 1;
        window.dispatchEvent(new Event(mutationEvent));
      }
      return rawFetch(...args).finally(() => {
        if (changesCart) {
          mutations -= 1;
          window.dispatchEvent(new Event(mutationEvent));
        }
      });
    };

    class MeltForwardGift extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.drawer = document.querySelector('cart-notification');
        const progress = this.drawer?.querySelector('.md-cart-progress');
        if (!progress || !this.querySelector('template')) return;
        this.initialized = true;
        this.panel = this.querySelector('template').content.firstElementChild.cloneNode(true);
        progress.after(this.panel);
        this.productId = String(this.dataset.productId);
        this.variantId = Number(this.dataset.variantId);
        this.startsAt = Date.parse(this.dataset.startsAt);
        this.endsAt = Date.parse(this.dataset.endsAt);
        this.available = false;
        this.availabilityConfirmed = false;
        this.safe = false;
        this.drawer.meltForward = { active: false, eligibleCents: 0 };
        this.onMutation = () => this.schedule(true);
        this.onResume = () => { if (!document.hidden) this.schedule(true); };
        this.onSubmit = (event) => {
          if (this.bypass || !(event.target instanceof HTMLFormElement)) return;
          const form = event.target;
          const submitter = event.submitter;
          if (submitter?.name !== 'checkout' && !(form.querySelector('[name="checkout"]') && !submitter)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.checkout(() => {
            this.bypass = true;
            try { form.requestSubmit(submitter || undefined); } finally { this.bypass = false; }
          });
        };
        this.onClick = (event) => {
          const anchor = event.target.closest('a[href]');
          if (!anchor || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const url = new URL(anchor.href, location.origin);
          if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.checkout(() => location.assign(anchor.href));
        };
        window.addEventListener(mutationEvent, this.onMutation);
        window.addEventListener('pageshow', this.onResume);
        document.addEventListener('visibilitychange', this.onResume);
        document.addEventListener('submit', this.onSubmit, true);
        document.addEventListener('click', this.onClick, true);
        this.openObserver = new MutationObserver(() => {
          if (this.drawer.classList.contains('is-active')) this.schedule(true);
        });
        this.openObserver.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
        this.itemsObserver = new MutationObserver(() => {
          if (this.drawer.lastCart && JSON.stringify(this.drawer.lastCart) !== this.cartSignature) this.schedule(false);
        });
        const items = this.drawer.querySelector('[data-md-cart-items]');
        if (items) this.itemsObserver.observe(items, { childList: true });
        this.pollTimer = window.setInterval(() => {
          if (!document.hidden && this.drawer.classList.contains('is-active')) this.schedule(true);
        }, 10000);
        if (this.endsAt >= Date.now()) this.expiryTimer = window.setTimeout(() => this.schedule(true), this.endsAt - Date.now() + 1);
        this.schedule(true);
      }

      disconnectedCallback() {
        window.removeEventListener(mutationEvent, this.onMutation);
        window.removeEventListener('pageshow', this.onResume);
        document.removeEventListener('visibilitychange', this.onResume);
        document.removeEventListener('submit', this.onSubmit, true);
        document.removeEventListener('click', this.onClick, true);
        this.openObserver?.disconnect();
        this.itemsObserver?.disconnect();
        window.clearInterval(this.pollTimer);
        window.clearTimeout(this.expiryTimer);
        window.clearTimeout(this.timer);
      }

      schedule(checkAvailability = false) {
        this.dirty = true;
        this.checkAvailability ||= checkAvailability;
        this.setPending(true);
        window.clearTimeout(this.timer);
        if (!this.running && !mutations) this.timer = window.setTimeout(() => this.run(), 60);
      }

      async run() {
        if (this.running || mutations) return this.running;
        this.running = this.drain();
        try { await this.running; } finally {
          this.running = null;
          this.setPending(Boolean(this.dirty || mutations));
          if (this.dirty && !mutations) this.schedule();
        }
      }

      async drain() {
        while (this.dirty && !mutations) {
          this.dirty = false;
          const refresh = this.checkAvailability;
          this.checkAvailability = false;
          this.safe = false;
          try {
            if (refresh) await this.refreshAvailability();
            let cart = await this.request(this.dataset.cartUrl);
            if (mutations) { this.dirty = true; continue; }
            cart = await this.reconcile(cart);
            this.safe = this.isCartSafe(cart) && !mutations;
            this.publish(cart);
          } catch (error) {
            this.failed = true;
            try {
              let cart = await this.request(this.dataset.cartUrl);
              cart = await this.removeGifts(cart);
              this.safe = this.isCartSafe(cart) && !mutations;
              this.publish(cart, 'error');
            } catch (cleanupError) {
              this.safe = false;
              this.showState('error');
              this.drawer.showError?.(this.dataset.copyError);
            }
          }
        }
      }

      async refreshAvailability() {
        if (!this.inTime()) { this.available = false; this.availabilityConfirmed = true; this.hidePromotion(); return; }
        try {
          const product = await this.request(this.dataset.productUrl);
          this.available = product.variants?.some((variant) => Number(variant.id) === this.variantId && variant.available === true) === true;
          this.availabilityConfirmed = true;
        } catch (error) {
          this.available = false;
          this.availabilityConfirmed = error.status === 404;
          this.hidePromotion();
          if (error.status !== 404) throw error;
        }
        if (!this.available) this.hidePromotion();
      }

      hidePromotion() {
        this.panel.hidden = true;
        this.drawer.meltForward = { ...this.drawer.meltForward, active: false };
        this.drawer.renderProgress(this.drawer.meltForward.eligibleCents || 0, this.drawer.lastCart?.currency || 'EUR');
      }

      inTime() { return Date.now() >= this.startsAt && Date.now() <= this.endsAt; }

      giftLines(cart) { return (cart.items || []).filter((item) => String(item.product_id) === this.productId); }

      isCartSafe(cart) {
        const gifts = this.giftLines(cart);
        if (!this.inTime() || cart.currency !== 'EUR' || this.eligibleSubtotal(cart) < 9900) return gifts.length === 0;
        if (!this.availabilityConfirmed) return false;
        if (!this.available) return gifts.length === 0;
        return gifts.length === 1 && gifts[0].quantity === 1 && gifts[0].final_line_price === 0;
      }

      eligibleSubtotal(cart) {
        return (cart.items || []).reduce((sum, item) => {
          if (String(item.product_id) === this.productId || item.gift_card || !this.eligibleIds.has(String(item.product_id))) return sum;
          return sum + Math.max(0, Number(item.final_line_price) || 0);
        }, 0);
      }

      async reconcile(cart) {
        const eligible = this.eligibleSubtotal(cart);
        if (!this.inTime() || !this.available || cart.currency !== 'EUR' || eligible < 9900) {
          this.failed = false;
          return this.removeGifts(cart);
        }
        let gifts = this.giftLines(cart);
        if (gifts.length > 1 || (gifts.length && gifts[0].quantity !== 1)) {
          cart = await this.removeGifts(cart);
          gifts = [];
        }
        if (!gifts.length && !this.failed) {
          this.publish(cart, 'adding');
          try {
            await this.request(this.dataset.addUrl, { items: [{ id: this.variantId, quantity: 1, properties: { _melt_it_forward: '2026-09-20' } }] });
          } catch (error) {
            if (error.status === 422 || error.status === 404) this.available = false;
            throw error;
          }
          cart = await this.request(this.dataset.cartUrl);
        }
        const finalGifts = this.giftLines(cart);
        if (!this.inTime() || this.eligibleSubtotal(cart) < 9900 || finalGifts.some((item) => item.final_line_price !== 0) || finalGifts.reduce((sum, item) => sum + item.quantity, 0) > 1) {
          this.failed = true;
          return this.removeGifts(cart);
        }
        return cart;
      }

      async removeGifts(cart) {
        for (let count = 0; this.giftLines(cart).length && count < 30; count += 1) {
          cart = await this.request(this.dataset.changeUrl, { id: this.giftLines(cart)[0].key, quantity: 0 });
        }
        if (this.giftLines(cart).length) throw new Error('Gift removal incomplete');
        return cart;
      }

      async request(url, body) {
        const response = await rawFetch(url, {
          method: body ? 'POST' : 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          signal: AbortSignal.timeout(10000),
          headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
          ...(body ? { body: JSON.stringify(body) } : {})
        });
        if (!response.ok) throw Object.assign(new Error('Cart request failed'), { status: response.status });
        return response.json();
      }

      publish(cart, state) {
        const active = this.inTime() && this.available && cart.currency === 'EUR';
        const eligibleCents = this.eligibleSubtotal(cart);
        const added = this.giftLines(cart).some((item) => item.quantity === 1 && item.final_line_price === 0);
        this.drawer.meltForward = { active, eligibleCents, added };
        this.panel.hidden = !active;
        document.documentElement.classList.toggle('md-forward-active', active || this.giftLines(cart).length > 0);
        this.showState(state || (this.failed ? 'error' : added ? 'added' : 'progress'));
        this.panel.querySelector('[data-forward-remaining]').textContent = this.drawer.formatMoney(Math.max(0, 9900 - eligibleCents), cart.currency);
        this.cartSignature = JSON.stringify(cart);
        if (JSON.stringify(this.drawer.lastCart) !== this.cartSignature) this.drawer.renderCart(cart);
        this.itemsObserver?.takeRecords();
        this.drawer.renderProgress(eligibleCents, cart.currency);
        const articles = this.drawer.querySelectorAll('.md-cart-item');
        (cart.items || []).forEach((item, index) => {
          if (String(item.product_id) !== this.productId || !articles[index]) return;
          const article = articles[index];
          article.classList.add('md-forward-line');
          const title = article.querySelector('.md-cart-item__title');
          if (title && !article.querySelector('.md-forward-line__badge')) {
            const badge = document.createElement('span');
            badge.className = 'md-forward-line__badge';
            badge.textContent = this.dataset.copyBadge;
            title.before(badge);
          }
          if (item.final_line_price === 0) article.querySelector('.md-cart-item__price').textContent = this.dataset.copyFree;
        });
      }

      showState(state) {
        this.panel.querySelectorAll('[data-forward-state]').forEach((node) => { node.hidden = node.dataset.forwardState !== state; });
      }

      setPending(pending) {
        document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach((button) => {
          if (pending && !button.hasAttribute('data-forward-pending')) {
            button.dataset.forwardPending = String(button.disabled);
            button.disabled = true;
            button.setAttribute('aria-busy', 'true');
          } else if (!pending && button.hasAttribute('data-forward-pending')) {
            button.disabled = button.dataset.forwardPending === 'true';
            button.removeAttribute('data-forward-pending');
            button.removeAttribute('aria-busy');
          }
        });
      }

      async checkout(proceed) {
        if (this.checkingOut) return;
        this.checkingOut = true;
        this.failed = false;
        this.schedule(true);
        try {
          const deadline = Date.now() + 20000;
          while (this.dirty || this.running || mutations) {
            if (Date.now() > deadline) throw new Error('Cart still pending');
            await new Promise((resolve) => window.setTimeout(resolve, 50));
          }
          if (this.safe) proceed();
          else this.drawer.showError?.(this.dataset.copyError);
        } catch (error) { this.drawer.showError?.(this.dataset.copyError); }
        finally { this.checkingOut = false; }
      }
    }

    MeltForwardGift.prototype.eligibleIds = new Set('14824340586822,14829269680454,14829271384390,14829475529030,14829476315462,14829476806982,15007203328326,15009025098054,15142571114822,15149014384966,15149111378246,15149749961030,15149758644550,15153402609990,15158994960710,15167517851974,15175071072582,15194401603910,15194409009478,15215686451526,15216244982086,15260094923078,15260099969350,15269565235526,15269567660358,15282164269382,15282293866822,15282334204230,15300994761030,15301529993542,15308854460742,15308855083334,15308857016646,15308857999686,15317359329606,15317359493446,15317359558982,15317359624518,15317359690054,15317359722822,15317359788358,15317359919430,15317359984966,15317360116038,15317360247110,15317360378182,15347824886086,15347897041222,15364447600966,15381321187654,15397763285318,15397767643462,15402065887558,15402485121350,15402493968710,15419126415686,15425296531782,15447368302918,15447374496070,15477057454406,15484392898886,15484399518022,15488102629702,15495709327686,15495716471110,15495720796486,15495721484614,15495721943366,15495722664262,15495723745606,15498597695814,15498599661894,15511703519558,15521496072518,15552804716870,15552807272774,15563714429254,15574696231238,15577246204230,15577257640262,15577279332678,15577281265990,15577299550534,15577302925638,15577304301894,15577306104134,15577312035142,15577351127366,15608195088710,15623650050374,15623655129414,15636759445830,15643625029958,15643628962118,15643631878470,15650728018246,15651201876294,15679770591558,15679777177926,15679958417734,15680074088774,15680085623110,15680087294278,15680096272710,15680097780038,15680100630854,15680108822854,15680412221766,15699871007046,15699871203654,15699871269190,15699871367494,15699871433030,15699871531334,15701574353222,15701890892102,15701929820486,15701929853254,15701929886022,15701929918790,15701929984326,15701930017094,15701930082630,15703812145478,15703921393990,15703964582214,15720824635718,15720850325830,15720855011654,15720864448838,15732877459782,15738065060166'.split(","));
    customElements.define('melt-forward-gift', MeltForwardGift);
  })();
  } catch(e) { console.error(e); }
})();

})();
